import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import { dayjs } from "../../Services/dateUtil";
import CommentIcon from "@mui/icons-material/Comment";
import DatasetIcon from "@mui/icons-material/Dataset";
import OutputIcon from "@mui/icons-material/Output";
const RenderField = ({ label, value }) => (
  <Grid container spacing={2} alignItems="center">
    <Grid item sm={4}><b>{label}</b></Grid>
    <Grid item sm={8}>{value}</Grid>
  </Grid>
);

const formatText = (string) =>
  string
    ? string.split("\\n").map((item, key) => (
        <span key={key}>
          {item}
          <br />
        </span>
      ))
    : "";

const parProperties = (string) => {
  try {
    const json = JSON.parse(string);
    return formatText(JSON.stringify(json, null, "\t"));
  } catch (e) {
    return string;
  }
};

const EntryDetails = ({ entry, entryDataset, promptId }) => {
  const entryData = entry;
  const loading = false;
  const [openPrompt, setOpenPrompt] = useState(false);
  const [openDatasets, setOpenDatasets] = useState(false);
  const [openResponse, setOpenResponse] = useState(false);

  const handleOpenPrompt = () => setOpenPrompt(true);
  const handleClosePrompt = () => setOpenPrompt(false);
  
  const handleOpenDatasets = () => setOpenDatasets(true);
  const handleCloseDatasets = () => setOpenDatasets(false);

  const handleOpenResponse = () => setOpenResponse(true);
  const handleCloseResponse = () => setOpenResponse(false);

const RenderFields = ({ entry, handleOpenPrompt, handleOpenDatasets, handleOpenResponse }) => (
  <Box p={2}>
    <Grid container spacing={1    }>
      <Grid item sm={6}><RenderField label="Id" value={entry.id}/></Grid>
      <Grid item sm={6}><RenderField label="Prompt Id" value={promptId}/></Grid>
      <Grid item sm={6}><RenderField label="Chat Id" value={entry.azureChatId}/></Grid>
      <Grid item sm={6}><RenderField label="Engine Name" value={entry.engineName}/></Grid>
      <Grid item sm={6}><RenderField label="Temperature" value={entry.temperature}/></Grid>
      <Grid item sm={6}><RenderField label="IsJson" value={entry.isJson !== undefined ? entry.isJson.toString() : "N/A"}/></Grid>
      <Grid item sm={6}><RenderField label="Prompt Tokens" value={entry.promptTokens}/></Grid>
      <Grid item sm={6}><RenderField label="Completion Tokens" value={entry.completionTokens}/></Grid>
      <Grid item sm={6}><RenderField label="Total Tokens" value={entry.totalTokens}/></Grid>
      <Grid item sm={6}><RenderField label="Executed At" value={dayjs.utc(entry.executedAt).local().format("lll")}/></Grid>
      <Grid item sm={6}><RenderField label="Finished At" value={dayjs.utc(entry.finishedAt).local().format("lll")}/></Grid>
      <Grid item sm={6}><RenderField label="Execution Status" value={entry.isSuccess ? "Success" : "Failed"}/></Grid>
      <Grid item sm={12}/>
      <Grid item sm={12}>
        <Grid container spacing={2}>
          <Grid item><Button variant="outlined" color="primary" onClick={handleOpenPrompt} startIcon={<CommentIcon/>}>
            See Prompt
          </Button></Grid>
          <Grid item><Button variant="outlined" color="primary" onClick={handleOpenDatasets} startIcon={<DatasetIcon/>} >
            See Datasets
          </Button></Grid>
          <Grid item><Button variant="outlined" color="primary" onClick={handleOpenResponse} startIcon={<OutputIcon/>} >
            See Response
          </Button></Grid>
        </Grid>
      </Grid>
    </Grid>

  </Box>
);

  if (loading) {
    return <CircularProgress />;
  }

  if (!entryData) {
    return <Typography variant="body2">No data available</Typography>;
  }

  return (
    <>
      <Grid container spacing={4} className="Details">
        <Grid item sm={12}>
          <RenderFields entry={entryData} handleOpenPrompt={handleOpenPrompt} handleOpenResponse={handleOpenResponse} handleOpenDatasets={handleOpenDatasets} />
        </Grid>
      </Grid>

      <Dialog open={openPrompt} onClose={handleClosePrompt} fullWidth maxWidth="md">
        <DialogTitle>Prompt</DialogTitle>
        <DialogContent>
          <Typography component="div" style={{ whiteSpace: "pre-wrap" }}>
            {parProperties(entryData.prompt)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePrompt} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openResponse} onClose={handleCloseResponse} fullWidth maxWidth="md">
        <DialogTitle>Response</DialogTitle>
        <DialogContent>
          <Typography component="div" style={{ whiteSpace: "pre-wrap" }}>
            {parProperties(entryData.response)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseResponse} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDatasets} onClose={handleCloseDatasets} fullWidth maxWidth="md">
        <DialogTitle>Datasets</DialogTitle>
        <DialogContent>
          <Typography component="div" style={{ whiteSpace: "pre-wrap" }}>
            {parProperties(entryDataset)}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDatasets} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EntryDetails;
